import { createSelector } from "reselect";

const devices = () => (state) => state.devices;

const selectDevicesContainer = () =>
  createSelector(
    devices(),
    ({ thermostat_devices, battery_devices, unassigned_battery_devices }) => ({
      ...thermostat_devices,
      batteries: battery_devices,
      unassignedBatteries: unassigned_battery_devices,
    })
  );

export default selectDevicesContainer;
